/* eslint-disable react-hooks/exhaustive-deps */
import { useParams } from 'react-router-dom';
import { BsCheck } from 'react-icons/bs';
import { useState, useEffect, useContext } from 'react';

import { RebrandShell } from 'components/rebrand/RebrandShell';
import { IconSprout } from 'components/rebrand/icons';
import { AuthContext, useAuth } from 'context/AuthContext';
import { getChallengeUser } from 'services/challenges.service';

import './styles.scss';

const BONUS = [
  { desafios: 2, estrelas: 100 },
  { desafios: 4, estrelas: 200 },
  { desafios: 5, estrelas: 300 },
];

export default function Challenges() {
  const params = useParams();

  const [list, setList] = useState<any[]>();
  const [optionsCycle, setOptionsCycle] = useState<any[]>([]);
  const [activeItem, setActiveItem] = useState('');
  const [loadingList, setLoadingList] = useState(true);

  const { userInfo } = useAuth();
  const { realCycle } = useContext(AuthContext);

  const [total, setTotal] = useState<number>(0);
  const [totalCompleted, setTotalCompleted] = useState<number>(0);

  useEffect(() => {
    async function loadData() {
      if (userInfo?.chave && activeItem) {
        setLoadingList(true);
        const data = await getChallengeUser(activeItem, params.id);
        const _data = data.filter((item: any) => !(userInfo.cad_missao === 0) || item._id !== 'DVi7Ajw');

        setTotalCompleted(_data.filter((item: any) => item.completed).length);
        setTotal(_data.length);
        setList(_data);
        setLoadingList(false);
      }
    }

    loadData();
  }, [userInfo, activeItem, params]);

  useEffect(() => {
    if (!realCycle) return;

    const cycleOptions = realCycle
      .filter((item: any) => item?.date_start >= 1690772400000)
      .map((cycle: any) => {
        cycle.label = 'Ciclo ' + cycle.title;
        cycle.value = cycle._id;
        return cycle;
      });

    setOptionsCycle(cycleOptions);
    if (cycleOptions.length && !activeItem) {
      setActiveItem(cycleOptions[0].value);
    }
  }, [realCycle]);

  function calculatePercentage(percentage: number | null, totalValue: number): number {
    if (!percentage) return 0;
    return Math.floor((totalValue / 100) * percentage);
  }

  function getTotal(item: any) {
    if (item?.extra?.total) return item.extra.total;
    if (item?.progress?.rules?.length) return item.progress.rules.length;
    return 1;
  }

  function verifyRules(item: any): number {
    if (!item?.progress) return 0;
    if (item?.progress?.rules?.length && item.progress.rules.length <= 2 && item.progress.rules[0]?.times_completed) {
      return item.progress.rules[0].times_completed;
    }
    if (item?.progress?.percent_completed) {
      return calculatePercentage(item.progress.percent_completed, getTotal(item));
    }
    return 0;
  }

  const overallPercent = total > 0 ? Math.round((totalCompleted / total) * 100) : 0;

  return (
    <RebrandShell
      title="Desafios"
      subtitle="Realize os desafios do mês e ganhe estrelas extras no seu saldo de reconhecimentos."
    >
      <section className="rb-challenge-bonus">
        <div className="rb-challenge-bonus__icon">
          <IconSprout color="#3f9a2f" size={26} />
        </div>
        <div>
          <div className="rb-challenge-bonus__title">Bonificação por desafios concluídos no ciclo</div>
          <div className="rb-challenge-bonus__tiers">
            {BONUS.map(b => (
              <span key={b.desafios} className="rb-challenge-bonus__tier">
                <b>{b.desafios} desafios</b> = {b.estrelas} estrelas
              </span>
            ))}
          </div>
        </div>
      </section>

      <div className="rb-challenge-toolbar">
        <div className="rb-challenge-progress">
          <div className="rb-challenge-progress__head">
            <span>Total de desafios concluídos</span>
            <b>
              {totalCompleted}/{total}
            </b>
          </div>
          <div className="rb-challenge-progress__bar">
            <div className="rb-challenge-progress__fill" style={{ width: `${overallPercent}%` }} />
          </div>
        </div>

        {optionsCycle.length > 0 && (
          <select
            className="rb-input rb-challenge-toolbar__select"
            value={activeItem}
            onChange={e => setActiveItem(e.target.value)}
            aria-label="Selecionar ciclo"
          >
            {optionsCycle.map((cycle: any) => (
              <option key={cycle.value} value={cycle.value}>
                {cycle.label}
              </option>
            ))}
          </select>
        )}
      </div>

      {loadingList && (
        <div className="rb-challenge-list">
          <div className="rb-skeleton" style={{ height: 120 }} />
          <div className="rb-skeleton" style={{ height: 120 }} />
        </div>
      )}

      {!loadingList && (!list || list.length === 0) && (
        <div className="rb-empty">Nenhum desafio disponível para este ciclo.</div>
      )}

      {!loadingList && !!list?.length && (
        <ul className="rb-challenge-list">
          {list.map((item: any) => {
            const done = item.completed;
            const current = done ? getTotal(item) : verifyRules(item);
            const goal = getTotal(item);
            return (
              <li key={item._id} className={`rb-challenge-card ${done ? 'is-done' : ''}`}>
                <div className="rb-challenge-card__head">
                  <p className="rb-challenge-card__title">{item.challenge}</p>
                  <div className="rb-challenge-card__status">
                    <span className="rb-challenge-card__count">
                      <b>{current}</b>/{goal}
                    </span>
                    <span className={`rb-challenge-card__check ${done ? 'is-done' : ''}`}>
                      <BsCheck size={26} />
                    </span>
                  </div>
                </div>
                {!!item.description && <p className="rb-challenge-card__desc">{item.description}</p>}
              </li>
            );
          })}
        </ul>
      )}
    </RebrandShell>
  );
}
